import { YouTubeIntegration } from 'api/clients/ExternalIntegrationsClient'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { LikeIcon, CommentIcon, ShareIcon, DislikeIcon } from './icons'
import { ArrowRefresh2, MoreDots } from 'blaze-ui/icons/20'
import Styles from './YouTubeShortPreview.module.scss'

interface ActionsProps {
  integration?: YouTubeIntegration
}

export const Actions = ({ integration }: ActionsProps) => {
  const { username, avatar } = integration
    ? extractProfileInfo(integration)
    : { username: 'user', avatar: Silhouette }

  return (
    <div className={Styles.actions}>
      <div className={Styles.action}>
        <LikeIcon />
        <span>223</span>
      </div>
      <div className={Styles.action}>
        <DislikeIcon />
        <span>23</span>
      </div>
      <div className={Styles.action}>
        <CommentIcon />
        <span>10</span>
      </div>
      <div className={Styles.action}>
        <ShareIcon />
        <span>3</span>
      </div>
      <div className={Styles.action}>
        <ArrowRefresh2 />
        <span>Remix</span>
      </div>
      <img src={avatar || Silhouette} alt={username} className={Styles.avatarFooter} data-testid="avatar-footer" />
    </div>
  )
}
